const SvgAssetManagement1 = (props) => (
  <>
    <path
      d="M156.52 57.89c2.17-2.74 3.48-6.19 3.48-9.96 0-8.86-7.18-16.04-16.04-16.04-4.07 0-7.78 1.53-10.61 4.04L28.32 100.04l.05.08C11.65 107.66 0 124.46 0 143.99c0 26.57 21.54 48.1 48.1 48.1 19.58 0 36.42-11.71 43.93-28.51l64.55-105.66-.07-.04ZM154 47.93c0 5.53-4.5 10.03-10.04 10.03s-10.03-4.5-10.03-10.03c0-2.81 1.16-5.35 3.03-7.17l.06-.04c1.81-1.75 4.25-2.83 6.95-2.83 5.53 0 10.04 4.5 10.04 10.04ZM48.1 186.1C24.88 186.1 6 167.21 6 144s18.89-42.1 42.1-42.1 42.1 18.89 42.1 42.1c0 5.99-1.27 11.7-3.54 16.86l-.37.61.08.05c-6.66 14.49-21.31 24.58-38.27 24.58Zm0-90.21c-.51 0-1.02.02-1.53.04l81.45-49.71c-.06.56-.09 1.14-.09 1.72 0 8.86 7.18 16.03 16.03 16.03.67 0 1.33-.05 1.98-.14L96.17 145.3c.01-.44.03-.87.03-1.31 0-26.57-21.54-48.1-48.1-48.1Z"
      fill={props.p20}
    />
    <path
      d="M48.1 127.96c-8.86 0-16.04 7.18-16.04 16.03s7.18 16.03 16.04 16.03 16.03-7.18 16.03-16.03-7.18-16.03-16.03-16.03Zm0 26.07c-5.53 0-10.04-4.5-10.04-10.03s4.5-10.03 10.04-10.03 10.03 4.5 10.03 10.03-4.5 10.03-10.03 10.03Z"
      fill={props.p20}
    />
  </>
);

export default SvgAssetManagement1;
